import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
export function ProtectedRoute({
  children
}: ProtectedRouteProps) {
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/signup" data-id="element-110" />;
  }
  return <>{children}</>;
}